import { createAction, props } from '@ngrx/store';

import { TaskListEntity } from '../../ui/components/app-task-modal/app-task-list.entity';

export enum TaskAction {
	OpenTaskModal = '[Core][Task] Open task modal',
	InitTaskList = '[Core][Task] Init task list',
	FetchTaskSuccess = '[BE][Core][Task] Fetch task success',
	FetchTaskFail = '[BE][Core][Task] Fetch task fail',
	RefreshTaskList = '[Core][Task] Refresh task list',
	UpdateViewActiveJobs = '[Core][Task] Update view active jobs',
	ToggleJobsCacheActive = '[Core][Task] Toggle active cache',
	ToggleJobsCacheActiveFail = '[Core][Task] Toggle active cache fail',
	KillAllJobs = '[Core][Task] Kill all jobs',
	KillAllJobsSuccess = '[BE][Core][Task] Kill all jobs success',
	KillAllJobsFail = '[BE][Core][Task] Kill all jobs fail',
	ClearCacheJobs = '[Core][Task] Clear cache jobs',
	ClearCacheJobsSuccess = '[BE][Core][Task] Clear cache jobs success',
	ClearCacheJobsFail = '[BE][Core][Task] Clear cache jobs fail',
	KillJob = '[Core][Task] Kill job',
	KillJobSuccess = '[BE][Core][Task] Kill jobs success',
	KillJobFail = '[BE][Core][Task] Kill jobs fail',
}

export const openTaskModal = createAction(TaskAction.OpenTaskModal);

export const initTaskList = createAction(TaskAction.InitTaskList);

export const fetchTaskSuccess = createAction(
	TaskAction.FetchTaskSuccess,
	props<{ taskList: TaskListEntity }>()
);

export const fetchTaskFail = createAction(
	TaskAction.FetchTaskFail,
	props<{ error: unknown }>()
);

export const refreshTaskList = createAction(TaskAction.RefreshTaskList);

export const updateViewActiveJobs = createAction(
	TaskAction.UpdateViewActiveJobs,
	props<{ activeJobs: boolean }>()
);

export const toggleJobsCacheActive = createAction(
	TaskAction.ToggleJobsCacheActive,
	props<{ activeCache: boolean }>()
);

export const toggleJobsCacheActiveSuccess = createAction(
	TaskAction.ToggleJobsCacheActive,
	props<{ activeCache: boolean }>()
);

export const toggleJobsCacheActiveFail = createAction(
	TaskAction.ToggleJobsCacheActiveFail,
	props<{ error: unknown }>()
);

export const killAllJobs = createAction(TaskAction.KillAllJobs);

export const killAllJobsSuccess = createAction(TaskAction.KillAllJobsSuccess);

export const killAllJobsFail = createAction(
	TaskAction.KillAllJobsFail,
	props<{ error: unknown }>()
);

export const clearCacheJobs = createAction(TaskAction.ClearCacheJobs);

export const clearCacheJobsSuccess = createAction(
	TaskAction.ClearCacheJobsSuccess
);

export const clearCacheJobsFail = createAction(
	TaskAction.ClearCacheJobsFail,
	props<{ error: unknown }>()
);

export const killJob = createAction(
	TaskAction.KillJob,
	props<{ jobId: string }>()
);

export const killJobSuccess = createAction(TaskAction.KillJobSuccess);

export const killJobFail = createAction(
	TaskAction.KillJobFail,
	props<{ error: unknown }>()
);
